import { Link } from 'react-router-dom';

export default function BrandSummary() {
  return (
    <section className="w-full min-h-screen flex flex-col justify-center py-20 md:py-28 bg-gradient-to-br from-primary-50 via-primary-100/60 to-secondary-100 overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05]">
        <div className="absolute top-10 left-10 w-64 h-64 border border-primary-300/25 rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-96 h-96 border border-secondary-300/20 rounded-full"></div>
        <div className="absolute top-1/2 left-1/3 w-48 h-48 border border-accent-400/20 rounded-full"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10 max-w-[1200px] mx-auto">
        <div className="text-center mb-4">
          <span className="inline-block text-xs tracking-[0.15em] text-primary-600 px-3 py-1 border border-primary-300 rounded-full">
            品牌資訊
          </span>
        </div>

        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 text-center mb-3">
          認識清文華泉
        </h2>
        <p className="text-sm md:text-base text-foreground-600 text-center mb-12 md:mb-16 font-heading">
          彩色知識、科普探索與歷史閱讀
        </p>

        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">
          <div className="flex-1 space-y-8">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              清文華泉以 AIGC 彩色書籍、科普與歷史類書籍為主要出版方向，透過圖像、知識內容與主題閱讀，提供兼具視覺呈現與知識性的出版內容。網站呈現清文華泉的品牌定位、2026 最新發行書籍與相關出版資訊。
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              <div className="p-4 rounded-xl bg-background-100/70 border border-background-200/60">
                <p className="text-[11px] tracking-[0.1em] text-foreground-500 mb-1">正式名稱</p>
                <p className="text-sm font-medium text-foreground-900">清文華泉事業有限公司</p>
              </div>
              <div className="p-4 rounded-xl bg-background-100/70 border border-background-200/60">
                <p className="text-[11px] tracking-[0.1em] text-foreground-500 mb-1">網站簡稱</p>
                <p className="text-sm font-medium text-foreground-900">清文華泉</p>
              </div>
              <div className="p-4 rounded-xl bg-background-100/70 border border-background-200/60">
                <p className="text-[11px] tracking-[0.1em] text-foreground-500 mb-1">英文名稱</p>
                <p className="text-sm font-medium text-foreground-900">CINVA</p>
              </div>
              <div className="p-4 rounded-xl bg-background-100/70 border border-background-200/60">
                <p className="text-[11px] tracking-[0.1em] text-foreground-500 mb-1">出版定位</p>
                <p className="text-sm font-medium text-foreground-900">AIGC 彩色書籍、科普與歷史類書籍</p>
              </div>
            </div>

            <div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-800 mb-4">
                出版內容方向
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="p-4 rounded-xl bg-accent-100/60 border border-accent-200/50">
                  <h4 className="text-sm font-semibold text-accent-800 mb-1.5">AIGC 彩色書籍</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    運用圖像與彩色內容呈現知識主題，提供更具視覺閱讀體驗的出版內容。
                  </p>
                </div>
                <div className="p-4 rounded-xl bg-secondary-100/60 border border-secondary-200/50">
                  <h4 className="text-sm font-semibold text-secondary-800 mb-1.5">科普類書籍</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    以自然、科學、知識探索及相關主題為主要內容。
                  </p>
                </div>
                <div className="p-4 rounded-xl bg-primary-100/60 border border-primary-200/50">
                  <h4 className="text-sm font-semibold text-primary-800 mb-1.5">歷史類書籍</h4>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    以歷史事件、人物、文化與相關人文知識為出版方向。
                  </p>
                </div>
              </div>
            </div>

            <div className="p-5 rounded-xl bg-background-100 border border-background-200">
              <p className="text-sm text-foreground-700 leading-relaxed">
                本品牌委託
                <a
                  href="https://sonbook.net/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-foreground-800 hover:text-primary-600 underline underline-offset-2 transition-colors duration-200 cursor-pointer"
                >
                  崧博出版
                </a>
                經銷，官方網站由崧博出版製作。
              </p>
              <p className="text-xs text-foreground-500 mt-2 leading-relaxed">
                完整書名、作者與出版資訊，請前往
                <a
                  href="https://catalog.sonbook.net/"
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-foreground-600 hover:text-primary-600 underline underline-offset-2 transition-colors duration-200 cursor-pointer"
                >
                  崧博書籍資料庫
                </a>
                查詢。
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <a
                href="https://catalog.sonbook.net/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                前往書籍資料庫
                <i className="ri-external-link-line"></i>
              </a>
              <Link
                to="/about"
                className="inline-flex items-center gap-2 px-5 py-2.5 border border-foreground-300/60 text-foreground-700 rounded-full text-sm font-medium hover:bg-foreground-950/5 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>

          <div className="lg:w-[320px] flex-shrink-0 flex justify-center lg:justify-end lg:pt-4">
            <div className="w-56 md:w-64 aspect-square rounded-xl overflow-hidden bg-background-100/60 border border-background-200/40 flex items-center justify-center p-6">
              <img
                src="https://storage.readdy-site.link/project_files/5a105479-8d38-448e-9522-af2f638a0e72/43972714-abc7-46e0-b45a-08a831bb46bf_logo-02-01.png"
                alt="清文華泉 Cinva 品牌標誌"
                title="清文華泉 Cinva 品牌標誌"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-8 border-t border-primary-200/30">
          <div className="text-center max-w-2xl mx-auto">
            <div className="flex items-center justify-center gap-2 mb-2">
              <i className="ri-book-open-line text-foreground-400 text-sm"></i>
              <span className="text-xs tracking-[0.1em] text-foreground-500">書目查詢入口</span>
            </div>
            <p className="text-xs text-foreground-500 leading-relaxed">
              網站中的「2026 最新發行」為清文華泉目前公開展示的新書內容。完整書目與出版資料由崧博書籍資料庫提供查詢。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}